import { h } from 'preact'
import Error from './Error'
import { CampaignType } from 'scripts/type'
import { getCampaignTypeName } from 'scripts/utils'

export default function NotFound({ campaignType }: { campaignType: CampaignType }) {
  return <Error title={`该${getCampaignTypeName(campaignType)}当前无法填写。`} code="not found" />
}
